<template>
  <div class="p-4">
    <div v-if="transactions.length === 0" class="text-gray-500">No transactions found.</div>
    <div v-else class="space-y-4">
      <div
        v-for="tx in transactions"
        :key="tx.id"
        class="p-4 border rounded-md hover:bg-gray-50 cursor-pointer transition-colors duration-200"
        @click="router.push(`/transaction/${tx.id}`)"
      >
        <div class="font-semibold">{{ tx.transaction_number }} - {{ tx.transaction_type }}</div>
        <div class="text-sm text-gray-600">
          {{ formatDate(tx.transaction_date) }} | {{ formatCurrency(tx.total_amount) }}
        </div>
        <div class="text-sm">Status: {{ tx.transaction_status }}</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useTransactionStore } from '@/stores/transactionStoreOld'
import { formatDate } from '@/utils/formatters'

const router = useRouter()

const props = defineProps<{ personId?: string; organizationId?: string }>()

const transactionStore = useTransactionStore()

const formatCurrency = (amount: number) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount)
}

onMounted(async () => {
  if (props.personId) {
    await transactionStore.fetchByPersonId(props.personId)
  } else if (props.organizationId) {
    await transactionStore.fetchByOrganizationId(props.organizationId)
  }
})

const transactions = computed(() => transactionStore.transactions)
</script>
